module.exports = __webpack_public_path__ + "static/img/fuel-generator_256.58dfa2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fuel-generator_256.png
// module id = Y5/t
// module chunks = 0